export var TransferSearchTimeType;
(function (TransferSearchTimeType) {
    TransferSearchTimeType["CREATED_AT"] = "created_at";
    TransferSearchTimeType["FINISHED_AT"] = "finished_at";
})(TransferSearchTimeType || (TransferSearchTimeType = {}));
//# sourceMappingURL=TransferSearchTimeType.js.map